// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Eb2h","resendInfoText":"OnGoingPaymentBox_resendInfoText__179fZ"};